import BuiltCampaignComponentVariable from "src/shared/store/component-built/setting/model/BuiltCampaignComponentVariable";
export const isBuiltCampaignComponentPartnerEnumListVariable = (setting) => {
    return setting instanceof BuiltCampaignComponentPartnerEnumListVariable;
};
class BuiltCampaignComponentPartnerEnumListVariable extends BuiltCampaignComponentVariable {
    constructor(response, context) {
        super(response, context);
        this.webhook_id = response.webhook_id;
        this.options = response.options;
    }
    getWebhookId() {
        return this.webhook_id;
    }
    getOptions() {
        return this.options;
    }
}
export default BuiltCampaignComponentPartnerEnumListVariable;
